import { render, staticRenderFns } from "./GridsCrud.vue?vue&type=template&id=a1eef120&scoped=true"
import script from "./GridsCrud.vue?vue&type=script&lang=js"
export * from "./GridsCrud.vue?vue&type=script&lang=js"
import style0 from "./GridsCrud.vue?vue&type=style&index=0&id=a1eef120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eef120",
  null
  
)

export default component.exports